import React from 'react';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

const textUtilities = basicEditorValueSerializer.utilities.text;

function Leaf(props) {

  function renderMain() {

    let { attributes, children, leaf } = props;

    if (leaf.bold) {
      children = <strong>{children}</strong>;
    }
    if (leaf.code) {
      children = <code>{children}</code>;
    }
    if (leaf.italic) {
      children = <em>{children}</em>;
    }
    if (leaf.underline) {
      children = <u>{children}</u>;
    }
    if (leaf.strikethrough) {
      const spanAttributes = {
        style: {
          textDecoration: 'line-through'
        }
      };
      children = <span {...spanAttributes}>{children}</span>;
    }

    const textColor = leaf.textColor;
    const backgroundColor = leaf.backgroundColor;
    const backgroundImage = leaf.backgroundImage;
    const fontFamily = leaf.fontFamily;
    const fontSize = leaf.fontSize;
    const fontWeight = leaf.fontWeight;
    const lineHeight = leaf.lineHeight;

    const styles = {};
    let className = '';

    if (leaf.aiSelectionHighlight === true) {
      className = 'ai-selection-highlight';
    }

    const leafAttributes = {
      ...attributes,
      className: className,
      style: styles
    };

    if (typeof textColor === 'string') {
      styles.color = textColor;
    }

    if (typeof backgroundColor === 'string') {
      styles.backgroundColor = backgroundColor;
    }

    if (typeof fontFamily === 'string') {
      styles.fontFamily = fontFamily;
    }

    if (typeof fontSize === 'string' && fontSize !== '') {
      styles.fontSize = textUtilities.fontSize(fontSize);
    }

    if (typeof fontWeight === 'number') {
      styles.fontWeight = fontWeight;
    }

    if (typeof lineHeight === 'string') {
      styles.lineHeight = textUtilities.lineHeight(lineHeight, fontSize);
      leafAttributes.className = (leafAttributes.className + ' leaf-line-height').trim();
    }

    if (typeof backgroundImage === 'string' && backgroundImage !== '') {
      styles.backgroundImage = backgroundImage;
      if (/gradient\(/i.test(backgroundImage) === true) {
        styles.WebkitBackgroundClip = 'text';
        styles.backgroundClip = 'text';
        styles.WebkitTextFillColor = 'transparent';
        styles.color = 'transparent';
      }
    }

    return <span {...leafAttributes}>{children}</span>;

  }

  return renderMain();

}

export default Leaf;